/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */
import React from "react";
import { NavLink } from "react-router-dom";

const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-container">
                <div className="footer-copyright">
                    <span>&copy; Bowen Island Municipality – All rights reserved.</span>
                    <span>&copy; District of North Vancouver – All rights reserved.</span>
                    <span>&copy; The Village of Lions Bay – All rights reserved.</span>
                    <span>&copy; District of West Vancouver – All rights reserved.</span>
                </div>
                <div className="footer-links">
                    <a className="built-with-simplicity" href="https://www.simplicitycms.ca/" target="_blank">
                        <span>Built with SimpliCity</span><sup>&trade;</sup>
                    </a>
                    <NavLink
                        aria-label="Privacy Policy"
                        to="/privacy-policy"
                    >
                            Privacy Policy
                    </NavLink>
                    <NavLink
                        aria-label="Terms of Use"
                        to="/terms-of-use"
                    >
                            Terms of Service
                    </NavLink>
                </div>
            </div>

        </div>
    );
};

export { Footer };
